import { render, staticRenderFns } from "./CadMonitoringViewResolver.vue?vue&type=template&id=bf2a4c6c&"
import script from "./CadMonitoringViewResolver.vue?vue&type=script&lang=js&"
export * from "./CadMonitoringViewResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports